module.exports = __webpack_public_path__ + "static/media/logomewah4.ed7c88f2.png";